import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum DownloadStatus {
  Initial = 'initial',
  Downloading = 'downloading',
  Import = 'import',
  Finished = 'finished',
  Error = 'error',
}

export type DownloadInfoProps = {
  url: string
  fileName: string
  progress: number
  isDownload: boolean
  downloadedSize: number
  error: boolean
}

export type DownloadsState = {
  status: DownloadStatus
  data: {
    [key: string]: DownloadInfoProps
  }
}

const INIT_DATA = {
  url: '',
  fileName: '',
  downloadedSize: 0,
  progress: 0,
  isDownload: false,
  error: false,
}

const initialState: DownloadsState = {
  status: DownloadStatus.Initial,
  data: {},
}

export const downloadsSlice = createSlice({
  name: 'downloads',
  initialState,
  reducers: {
    addItemToDownloadState: (state, action: PayloadAction<string>) => {
      state.data[action.payload] = INIT_DATA
    },
    setDownloadState: (
      state,
      action: PayloadAction<{ key: string; data: Partial<DownloadInfoProps> }>,
    ) => {
      const { key, data } = action.payload
      state.data[key] = { ...state.data[key], ...data }
    },
    setDownloadStatus: (state, action: PayloadAction<DownloadStatus>) => {
      state.status = action.payload
    },
  },
})

export const { setDownloadState, addItemToDownloadState, setDownloadStatus } =
  downloadsSlice.actions

export default downloadsSlice.reducer
